import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

export default class InvoiceApi {
  static async getInvoicePdf(invoiceId, headers) {
    const config = getApiConfig();
    const url = `/api/invoice/api/v1/invoices/${invoiceId}.pdf`;
    const res = await axios.get(url, {
      headers,
      responseType: 'blob',
    });
    return res.data;
  }
}
